"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _prismic = require("../../shared/helpers/prismic");

var _BasicPageTitle = _interopRequireDefault(require("../components/PageTitle/BasicPageTitle"));

var _PageHero = _interopRequireDefault(require("../components/PageHero/PageHero"));

var _ResponsiveHero = _interopRequireDefault(require("../components/ResponsiveHero/ResponsiveHero"));

var _CardList = _interopRequireDefault(require("../components/CardList/CardList"));

var _EnergyCostGraph = _interopRequireDefault(require("../components/EnergyCostGraph/EnergyCostGraph"));

var _SectionList = _interopRequireDefault(require("../components/SectionList/SectionList"));

var _BasicSectionTitle = _interopRequireDefault(require("../components/SectionTitle/BasicSectionTitle"));

var _SectionBody = _interopRequireDefault(require("../components/SectionBody/SectionBody"));

var _SectionImages = _interopRequireDefault(require("../components/SectionImages/SectionImages"));

var _ResponsiveImage = _interopRequireDefault(require("../components/ResponsiveImage/ResponsiveImage"));

var _HeroCard = _interopRequireDefault(require("../components/HeroCard/HeroCard"));

var _SectionTable = _interopRequireDefault(require("../components/SectionTable/SectionTable"));

var _SectionCTALink = _interopRequireDefault(require("../components/SectionCTALink/SectionCTALink"));

var _SectionContactInfo = _interopRequireDefault(require("../components/SectionContactInfo/SectionContactInfo"));

var _SectionContactInfoSingle = _interopRequireDefault(require("../components/SectionContactInfo/SectionContactInfoSingle"));

var _SectionInfoCard = _interopRequireDefault(require("../components/SectionInfoCard/SectionInfoCard"));

var _SectionExpandableList = _interopRequireDefault(require("../components/SectionExpandableList/SectionExpandableList"));

var _Divider = _interopRequireDefault(require("../components/Divider/Divider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var BasicPageTemplate = function BasicPageTemplateComponent(_ref) {
  var dataClient = _ref.dataClient,
      pageData = _ref.pageData;
  var sections = pageData.sections,
      linkedContent = pageData.linkedContent;
  var componentMap = {
    energy_cost_graph: _EnergyCostGraph["default"],
    page_hero: _PageHero["default"],
    responsive_hero: _ResponsiveHero["default"],
    section_page_title: _BasicPageTitle["default"],
    section_title: _BasicSectionTitle["default"],
    section_body: _SectionBody["default"],
    divider: _Divider["default"],
    section_card_list: _CardList["default"],
    section_list: _SectionList["default"],
    section_images: _SectionImages["default"],
    section_hero_card: _HeroCard["default"],
    section_table: _SectionTable["default"],
    section_cta_link: _SectionCTALink["default"],
    section_responsive_image: _ResponsiveImage["default"],
    section_contact_info: _SectionContactInfo["default"],
    section_contact_info_single: _SectionContactInfoSingle["default"],
    section_info_card: _SectionInfoCard["default"],
    section_expandable_list: _SectionExpandableList["default"]
  };
  var slices = (0, _prismic.nestSlices)(sections);
  var props = {
    dataClient: dataClient,
    linkedContent: linkedContent
  };
  return (0, _prismic.slicesToJsx)(slices, componentMap, props);
};

BasicPageTemplate.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  pageData: _propTypes["default"].shape({}).isRequired
};
var _default = BasicPageTemplate;
exports["default"] = _default;